export default __webpack_public_path__ + "static/media/login-logo.cde90b21.png";